import { render, staticRenderFns } from "./TopicFeedbackModal.vue?vue&type=template&id=13398676"
import script from "./TopicFeedbackModal.vue?vue&type=script&lang=js"
export * from "./TopicFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./TopicFeedbackModal.vue?vue&type=style&index=0&id=13398676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports